import {allRouteDefinitions} from '../../routing/routing.config';
import {RouteDef} from '../../routing/routing.types';
import {RouteKey} from '../../routing/routing.enums';

const beforeGoListeners: {current: {id: string; callback: () => boolean}[]} = {
  current: [],
};

const allRouteDefs: Record<RouteKey, RouteDef> = allRouteDefinitions;

export {allRouteDefs, beforeGoListeners};
